<template>
  <p
    v-if="hasError"
    class="text-sm text-supplement"
  >
    {{ $t('share_qr_code_error', 'We couldn\'t create a QR code for this link. Please check the link and try again.') }}
  </p>
  <div
    v-else
    class="md:flex"
  >
    <div class="relative grid h-[160px] w-[160px] flex-shrink-0 place-items-center bg-gray-50">
      <Icon
        icon="spinner-third"
        prefix="fad"
        spin
        class="text-2xl"
      />
      <img
        :src="url"
        height="160"
        width="160"
        class="absolute inset-0"
        @error="hasError = true"
      />
    </div>
    <div class="space-y-6 md:ml-10">
      <p class="mt-6 md:mt-0">
        {{ $t('share_qr_code_description') }}
      </p>
      <p>
        <Button
          as="a"
          :href="withQuery(url, { download: '' })"
          prepend-icon="cloud-arrow-down"
          color="brand"
        >
          {{
            $t('download_qr_code')
          }}
        </Button>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { withQuery } from 'ufo'

const props = defineProps<{
  url: string
}>()

const hasError = ref(false)
watch(() => props.url, () => (hasError.value = false))
</script>
